import { useContext } from "react"
import styles from "./index.module.scss"
import { GenerateContext } from "../../../hooks/GenerateContext"
import { GENERATE_MODE } from "@utils/CONST"
import Iconfont from '@utils/Iconfont';

const GenerateMode = (props) => {
    const {
        generateMode, setGenerateMode
    } = useContext(GenerateContext)

    const items = [{
        value: GENERATE_MODE.STD,
        title: "标准模式",
        content: "生成速度更快",
        icon: <Iconfont type="icon-stdOutlined" />,
        iconActive: <Iconfont type="icon-stdFilled" />,
    }, {
        value: GENERATE_MODE.HQ,
        title: "高品质模式",
        content: "生成效果更好",
        icon: <Iconfont type="icon-hdOutlined" />,
        iconActive: <Iconfont type="icon-hdFilled" />,
        // 限免
        // isLimit: true,
    }]

    return (
        <div className={styles.Container}>
            <p className={styles.Title}>生成模式</p>
            <div className={styles.PickerContent}>
            {
                items.map(item => (
                    <div
                        key={item.value}
                        className={`${styles.PickerItem} ${item.isLimit && styles.isLimit} ${generateMode == item.value && styles.actived}`}
                        onClick={() => setGenerateMode(item.value)}
                    >
                        <div className={styles.Title}>
                            {generateMode == item.value ? item.iconActive : item.icon}
                            <span>{item.title}</span>
                        </div>
                        <span className={styles.Content}>{item.content}</span>
                    </div>
                ))
            }
            </div>
        </div>
    )
}

export default GenerateMode